import { Image } from '@heroui/react';
import { useTranslation } from 'react-i18next';

import ErrorImage from '@/assets/images/error.png';

export function NoMatch() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center">
      <Image src={ErrorImage} width={800} disableSkeleton />
      <h1 className="text-2xl">{t('common.error.not_found')}</h1>
      <p className="font-light">{t('common.layout.not_found')}</p>
    </div>
  );
}
